import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { User } from "../../services/user";
import { Api } from "../../services/api";
import { sharedData } from "../../services/vars";
import { Purchase } from "../../services/purchase";
import { BindAccountPage } from "../bind-account/bind-account";
import { ShareCard } from "../../services/sharecard";

/**
 * Generated class for the MyCampaignsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "my-campaigns",
})
@Component({
  selector: "page-my-campaigns",
  templateUrl: "my-campaigns.html",
})
export class MyCampaignsPage {
  showType = "mine";
  window = window;
  list;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private user: User,
    private api: Api,
    private purchase: Purchase,
    private shareCard: ShareCard
  ) {}

  onSegmentChange() {
    this.list = null;
    this.fetchData();
  }

  fetchData() {
    if (this.showType === "settings") {
      return;
    }
    this.list = null;
    this.api.getCampaignsList(this.showType).then((_) => (this.list = _));
  }

  ionViewDidLoad() {
    this.api.collect({ event: "my-campaign", attr: {} });
  }

  ionViewDidEnter() {
    document.title = "我的活动";

    this.shareCard.share({
      title: "我的活动",
      desc: "我的活动",
      link: location.href,
      imgUrl: "",
    });

    this.fetchData();

    window["refreshMyCampaigns"] = () => this.fetchData();
  }

  doShare(item) {
    sharedData.showShareGuideFlag = true;
    window.location.hash = `#/campaign/${item.id}`;
  }

  showPurchase(item) {
    this.purchase.purchaseCampaign(item.id);
  }

  viewDetail(item) {
    window.location.hash = `#/campaign/${item.id}`;
  }

  orderDetail(item) {
    window.location.hash = `#/order/${item.id}`;
  }

  showItemDetail(item) {
    window.location.hash = `#/item/${item.item_id}`;
  }

  showBindAccount() {
    window["bindAccountCallback"] = null;
    this.navCtrl.push(BindAccountPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/my-campaigns/my-campaigns.ts